import { navigate } from "gatsby";
import { setResumeParameter } from "@helpers/SugarcubeNavigation";
import { createSimpleEventEmitter } from "@utils/simple-event-emitter";

const actions = {
  NAVIGATE_BACK: "NAVIGATE_BACK",
  SET_RESUME_PARAM: "SET_RESUME_PARAM",
  REQUEST_STORE_SELECTION_CHANGE: "REQUEST_STORE_SELECTION_CHANGE",
  REQUEST_STORE_SELECTION: "REQUEST_STORE_SELECTION",
  REQUEST_POSTALCODE_PICKER: "REQUEST_POSTALCODE_PICKER",
};

const awaitStore = (source = {}, targetOrigin) => {
  const storeId = new Promise((resolve) =>
    window.ikea.pubsub.subscribe("NAVIGATION/STORE_SET", (storeId) => {
      resolve(storeId);
    })
  );

  storeId.then((storeId) => {
    source?.postMessage(
      {
        type: "STORE_SELECTION_CHANGE_STORE_ID",
        storeId,
      },
      targetOrigin
    );
  });
};

const awaitPostalCode = (source = {}, targetOrigin) => {
  const zipCode = new Promise((resolve) =>
    window.ikea.pubsub.subscribe("NAVIGATION/POSTALCODE_SET", (zipObject) => {
      const zip = zipObject?.postalCode;
      resolve(zip);
    })
  );

  zipCode.then((zipCode) => {
    source?.postMessage(
      {
        type: "STORE_SELECTION_CHANGE_ZIP_CODE",
        zipcode: zipCode,
      },
      targetOrigin
    );
  });
};

const getInitialStoreAndZipCode = async (source, targetOrigin) => {
  const storeId = await window.ikea.store.get();
  const zipCode = await window.ikea.postalCode.get();
  source?.postMessage(
    {
      type: "STORE_SELECTION_UPDATED",
      storeId,
      zipcode: zipCode?.postalCode,
    },
    targetOrigin
  );
};

const handleSugarcubeEvents = (message) => {
  const { data = {}, source } = message;
  switch (data.type) {
    case "GET_TOKENS": {
      if (window.ikea && window.ikea.authentication) {
        window.ikea.authentication.getTokens((error, tokens) =>
          source.postMessage(
            {
              type: "GET_TOKENS_RESPONSE",
              tokens,
              error,
              isDev: window.location.hostname.includes(".cte."),
            },
            message.origin
          )
        );
      }
      break;
    }
    case actions.NAVIGATE_BACK:
      navigate("/");
      break;
    case actions.SET_RESUME_PARAM:
      setResumeParameter();
      break;
    case actions.REQUEST_STORE_SELECTION_CHANGE:
      window.ikea.pubsub.publish("NAVIGATION/OPEN_STORE_PICKER");
      awaitStore(source, message.origin);
      break;
    case actions.REQUEST_POSTALCODE_PICKER:
      window.ikea.pubsub.publish("NAVIGATION/OPEN_POSTALCODE_PICKER");
      awaitPostalCode(source, message.origin);
      break;
    case actions.REQUEST_STORE_SELECTION:
      getInitialStoreAndZipCode(source, message.origin);
      break;
    default: {
      break;
    }
  }
};

export const addSugarcubeListener = () => {
  const pubsub = createSimpleEventEmitter({ debug: false });
  const onWindowMessage = (message) => {
    if (!message.origin.startsWith("https://") || !message.origin.endsWith(process.env.GATSBY_SUGARCUBE_ORIGIN)) {
      return;
    }
    pubsub.pub(message);
  };
  window.addEventListener("message", onWindowMessage);
  pubsub.sub(handleSugarcubeEvents);
  return pubsub;
};
